/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const JobApplicationState = {
    NotInterested: 'NotInterested',
    Waiting: 'Waiting',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Closed: 'Closed'
};
export function instanceOfJobApplicationState(value) {
    for (const key in JobApplicationState) {
        if (Object.prototype.hasOwnProperty.call(JobApplicationState, key)) {
            if (JobApplicationState[key] === value) {
                return true;
            }
        }
    }
    return false;
}
export function JobApplicationStateFromJSON(json) {
    return JobApplicationStateFromJSONTyped(json, false);
}
export function JobApplicationStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function JobApplicationStateToJSON(value) {
    return value;
}
export function JobApplicationStateToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
